export function roundNumber(input: number, decimals = 2): number {
    return Math.round(input * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
